var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarlightIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#95A9B2",
    stroke: "none",
    points: "110.45 98.45 74.62 7 105.96 100.08 19.73 53.06 103.57 104.22 7.29 123.62 104.4 108.92 43.12 185.67 108.06 111.99 110.45 210.18 112.84 111.99 177.78 185.67 116.5 108.92 213.6 123.62 117.33 104.22 201.16 53.06 114.94 100.08 146.27 7 110.45 98.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlightIconLight);
export default __webpack_public_path__ + "static/media/starlight-icon-light.b3cb26a171704a8e6496e519c6dbe5e6.svg";
export { ForwardRef as ReactComponent };